import type { CollaborationNotesAdapter } from '~publish/components/CollaborationNotes'
import { insertCreatedNote } from '~publish/hooks/notes/notesCache'
import type { ContentItemNoteSubject } from '~publish/hooks/notes/noteSubject'
import { useContentItemNoteChanges } from '~publish/hooks/notes/useContentItemNoteChanges'
import { useCreateNote } from '~publish/hooks/notes/useCreateNote'
import { useDeleteNote } from '~publish/hooks/notes/useDeleteNote'
import { useNotes } from '~publish/hooks/notes/useNotes'
import { useUpdateNote } from '~publish/hooks/notes/useUpdateNote'

/**
 * A ContentItem's own Notes through the `subject` input. The thread stays
 * live through its own `collaborationNoteSubjectChanges` stream while it is
 * open.
 */
export const contentItemNotesAdapter: CollaborationNotesAdapter<ContentItemNoteSubject> =
  {
    useNotes,
    useCreateNote,
    useUpdateNote,
    useDeleteNote,
    insertCreatedNote: (cache, subject, edge) =>
      insertCreatedNote(cache, subject, edge),
    useSubscribe: ({ subjectId }) => useContentItemNoteChanges(subjectId),
    // Read state is kept for Post threads only.
    useReadState: () => null,
  }
